/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const InputEnumPropertyOption = core.serialization.object({
    label: core.serialization.string().optional(),
    description: core.serialization.string().optional(),
    color: core.serialization.string().optional(),
    icon: core.serialization.string().optional(),
    meta: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    value: core.serialization.any(),
});
